import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';

import { Typography } from '@material-ui/core';

import { convertToEstablishmentName, convertToBrl } from 'helpers/converters';
import { formatPhone, formatVehicle, formatPermanence } from 'helpers/formatters';
import { formatCurrency } from 'helpers/converters';

import '../styles.css';

const header = [
  { title: 'Nº' },
  { title: 'Cliente' },
  { title: 'Veículo' },
  { title: 'Data Entrada' },
  { title: 'Data Saída' },
  { title: 'Permanência' },
  { title: 'Operador' },
  { title: 'Operador Saída' },
  { title: 'Cobrança' },
  { title: 'Serviços' },
  { title: 'Produtos' },
  { title: 'Pagamento' },
  { title: 'Desconto' },
  { title: 'Valor' }
];

const OperationalHistoryExport = React.forwardRef((props, ref) => {
  const { establishmentId } = useSelector(state => state.businessInfo);
  const { establishments } = useSelector(state => state.login);
  const { startDate, endDate } = useSelector(state => state.dateFilter);

  const establishmentName = convertToEstablishmentName(establishmentId, establishments) || 'Todos os estabelecimentos';

  const formattedData = props?.data?.content?.length > 0 && props?.data?.content?.map(item => {
    return {
      establishmentName: item?.establishmentName || '-',
      serviceOrderCode: item?.serviceOrderCode || '-',
      clientName: item?.clientName || '-',
      clientPhone: !!item?.clientPhone ? formatPhone(JSON.parse(item?.clientPhone)) : '',
      clientEmail: item?.clientEmail || '',
      vehicle: `${formatVehicle({ vehicleColor: item?.vehicleColor, vehicleModel: item?.vehicleModel })} ${item?.plate || ''}`,
      entryDateTime: moment(item?.entryDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
      exitDateTime: moment(item?.exitDateTime, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss'),
      permanence: formatPermanence([item?.exitDateTime, item?.entryDateTime]),
      userName: item?.userName || '-',
      userOutputName: item?.userOutputName || '-',
      typePrice: item?.typePrice || '-',
      services: item?.services,
      products: item?.products,
      paymentMethodName: item?.paymentMethodName || '-',
      discountAmount: item?.discountAmount ? convertToBrl(parseFloat(item?.discountAmount)) : '-',
      amount: convertToBrl(parseFloat(item?.totalAmount))
    }
  });

  return(
    <div ref={ref} style={{ width: '100%', padding: 10 }}>
      <div>
        <Typography variant='h5'>
          Histórico Operacional
        </Typography>
      </div>
      <div>
        <Typography>
          {establishmentName}
        </Typography>
      </div>
      <div>
        <Typography>
          Período: {moment(startDate, 'YYYY-MM-DD').format('DD/MM/YYYY')} - {moment(endDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
        </Typography>
      </div>
      <div style={{ width: '100%', marginTop: 20 }}>
        <table style={{ width: '100%', tableLayout: 'fixed', border: '1px solid #000000', borderCollapse: 'collapse' }}>
          <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              Total de OS alterada
            </td>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              {props?.data?.resume?.totalUpdated?.toString() || '-'}
            </td>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              Total de OS paga
            </td>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              {props?.data?.resume?.totalPaid?.toString() || '-'}
            </td>
          </tr>
          <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              Total de OS cancelada
            </td>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              {props?.data?.resume?.totalSoCanceled?.toString() || '-'}
            </td>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              Total de OS
            </td>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              {formatCurrency(props?.data?.resume?.totalAmount) || '-'}
            </td>
          </tr>
          <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              Total de OS isenta
            </td>
            <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5 }}>
              {props?.data?.resume?.totalFreeSituations?.toString() || '-'}
            </td>
          </tr>
        </table>
        <table style={{ width: '100%', tableLayout: 'fixed', border: '1px solid #000000', borderCollapse: 'collapse' }}>
          <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
            {!establishmentId && (
              <th style={{ borderRight: 'thin solid', textAlign: 'left', padding: 5 }}>
                Estabelecimento
              </th>
            )}
            {header.map(item => (
              <th style={{ borderRight: 'thin solid', textAlign: 'left', padding: 5 }}>
                {item.title}
              </th>
            ))}
          </tr>
          {formattedData?.length > 0 && formattedData?.map(item => (
            <tr style={{ width: '100%', borderBottom: 'thin solid' }}>
              {!establishmentId && (
                <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.establishmentName}</td>
              )}
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.serviceOrderCode}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {item?.clientName}
                <br />
                <br />
                {item?.clientPhone}
                <br />
                <br />
                {item?.clientEmail}
              </td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.vehicle}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.entryDateTime}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.exitDateTime}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.permanence}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.userName}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.userOutputName}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.typePrice}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {item?.services?.map(service => {
                  return(
                    <p>
                      {service?.description} {service?.quantity ? `(${service?.quantity})` : ''} - {convertToBrl(+service?.amount)}
                    </p>
                  );
                })}
              </td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word', wordBreak: 'break-all' }}>
                {item?.products?.map(product => {
                  return(
                    <p>
                      {product?.description} {product?.quantity ? `(${parseInt(product?.quantity)})` : ''} - {convertToBrl(+product?.amount)}
                    </p>
                  );
                })}
              </td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.paymentMethodName}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.discountAmount}</td>
              <td style={{ borderRight: 'thin solid', color: '#505050', padding: 5, wordWrap: 'break-word' }}>{item?.amount}</td>
            </tr>
          ))}
        </table>
      </div>
      <div style={{ backgroundColor: '#E2E2E2', padding: 10, border: '1px solid #000000', borderTop: 'none' }}>
        {(+props?.data?.total == 1) ? (
          <p style={{ color: '#505050', margin: 0 }}>
            Este relatório tem {props?.data?.total} item.
          </p>
        ) : (
          <p style={{ color: '#505050', margin: 0 }}>
            Este relatório tem {props?.data?.total} itens.
          </p>
        )}
      </div>
    </div>
  );
});

export default OperationalHistoryExport;